import * as yup from "yup";

export const LoginSchema = yup.object().shape({
  email: yup.string().email().required("Email is required"),
  password: yup
    .string()
    .min(6, ({ min }) => `Password must be at least ${min} characters`)
    .required("Password is required"),
});

export const CreateStoreSchema = yup.object().shape({
  brand_name: yup.string().required("Brand name is required"),
  description: yup.string().required("Description is required"),
  city: yup.string().required("City is required"),
  street: yup.string().required("Street is required"),
  state: yup.string().required("state is required"),
  phone_number: yup.string().required("Phone number is required"),
  img_url: yup.string().required("image is required"),
});
export const RegisterSchema = yup.object().shape({
  first_name: yup.string().required("First name is required"),
  last_name: yup.string().required("Last name is required"),
  email: yup.string().email().required("Email is required"),
  password: yup
    .string()
    .min(6, ({ min }) => `Password must be at least ${min} characters`)
    .required("Password is required"),
  agreement: yup.string().required("T & C required"),
});

export const ContactSchema = yup.object().shape({
  firstName: yup.string().required("first name is required"),
  lastName: yup.string().required("last name is required"),
  email: yup.string().email().required("Email is required"),
  subject: yup.string().required("Subject is required"),
  message: yup.string().required("Message is required"),
});

export const ShippingSchema = yup.object().shape({
  fullName: yup.string().required("fullName is required"),
  phone: yup.string().required("Phone no is required"),
  address: yup.string().required("Address is required"),
  city: yup.string().required("City is required"),
  region: yup.string().required("State is required"),
});

export const newProductSchema = yup.object().shape({
  name: yup.string().required(" Name is required"),
  description: yup.string().required("Description is required"),
  store_id: yup.string().required("Store id is required"),
  category_id: yup.string().required("Category is required"),
  estimated_delivery_duration: yup
    .string()
    .required("delivery duration is required"),
});

export const newProductSpecSchema = yup.object().shape({
  quantity: yup.number().required("Quantity is required"),
  amount: yup.number().required("Amount is required"),
  size: yup.string().required("Size is required"),
});
export const CreateCategorySchema = yup.object().shape({
  category: yup.string().required("category is required"),
});
